<template>
    <vs-prompt
        @cancel="cancelAlert"
        @accept="acceptAlert"
        :active.sync="promptConfig.isOpen"
        type="confirm"
        title="OTP Verification"
        class="otp-verification-prompt"
    >
        <div class="con-exemple-prompt">
            Enter OTP sent to your mobile number
            <div class="flex align-center mb-base">
                <vs-input
                    placeholder="OTP"
                    v-model="otp"
                    class="otp-input w-full"
                    @keyup.enter="acceptAlert"
                    @keypress="isNumber($event)"
                    @input="validate"
                />
                <vs-button class="resend-btn" @click="resendOTP" :disabled="count > 0">Resend <span v-if="count">({{ count }}s)</span></vs-button>
            </div>
            <!-- <p>Resend OTP in 60s</p> -->
        </div>
    </vs-prompt>
</template>

<script>
export default {
    name: "otp-verification-prompt",
    props: {
        promptConfig: {
            type: Object
        }
    },
    data() {
        return {
            otp: "",
            count: 60
        }
    },
    watch: {
        promptConfig: {
            immediate: true,
            deep: true,
            handler() {
                if(this.promptConfig.isOpen) {
                    this.initCountNumber();
                }
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.sendOTP();
        })
    },
    methods: {
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        initCountNumber() {
            this.count = 60;
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.count--;
                if(this.count <= 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        resendOTP() {
            if(this.count <= 0) {
                this.sendOTP();
                this.initCountNumber();
            }
        },
        sendOTP() {

        },
        validate() {

        },
        acceptAlert() {
            this.promptConfig.isOpen = true;
        },
        cancelAlert() {
            
        },
    }
}
</script>

<style lang="scss">
.otp-verification-prompt {
    .otp-input {
        input {
            border-radius: 5px 0 0 5px;
        }
    }
    .vs-input--placeholder.normal {
        padding: 1rem !important;
    }
    .resend-btn {
        padding: 0.75rem 1rem !important;
        height: 42.59px;
        min-width: 123px;
        border-radius: 0 5px 5px 0;
    }
}
</style>